import "../../css/service/service.css";
import React, {useState} from "react";
import {authYandex, authGoogle, useTheme} from "../header/Header";
import {GoogleIcon, YandexIcon} from "../utils/Icons";
import {OrderForm} from "../product/ProductCard";
import {useLocation} from "react-router-dom"
import {GalleryList} from "../utils/utils";
import SeoHelmet from "../utils/seo";
import Navigation from "../utils/Navigation";
import {findElementByLink} from "../utils/siteStructure";
import {AlertNoCancel} from "../crm/feedback";
import siteStructure from "../siteStructure.json";
import serviceDescription from "../serviceDescription.json";


export function ServiceTextBackground({text, image}){

    const {theme} = useTheme()

    return (
        <div className={`serviceTextBackground ${theme}`}>
            <img src={image} alt="no-img"/>
            <div className={`serviceBackgroundImageColor ${theme}`}> </div>
            <div className={"serviceBackgroundH1Wrapper"}>
                <h1>Услуги</h1>
                <h1>{text}</h1>
            </div>
        </div>
    )

}

export function ServiceSteps({firstParagraph, title, stepsText, theme}){

    const arrowColor = theme === "dark" ? "#ffffff" : "#000000"

    return (
        <div className={`serviceSteps ${theme}`}>
            <p>{firstParagraph}</p>
            <h3>{title}</h3>
            <div>
                {stepsText.map((step, i)=>{
                    return (
                        <div key={`step_${i}`} className={`serviceStepWrapper ${theme}`}>
                            <div className={`serviceStepsArrowString ${theme}`}>
                                <span>Шаг </span>
                                <span>{i + 1}</span>
                                {i === stepsText.length - 1? null :
                                    <svg xmlns="http://www.w3.org/2000/svg" width="70%" height="10" viewBox="0 0 226 10">
                                        <path d="m9.473 5.5a4.5 4.5 0 1 1 0-1h5.027v1zm-7.973-.5a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0 -7 0zm224 0-9 4.5v-9zm-206 .5v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1zm11 0v-1h6v1z" fill={arrowColor} opacity=".8"/>
                                    </svg>
                                }
                            </div>
                            <p>{step}</p>
                        </div>
                    )
                })}
            </div>
        </div>
    )

}

export function ServiceMainContent({title, image, texts, theme, position=false}) {

    function getTagType(text){
        switch (text.type) {
            case "p":
                return (<p>{text.content}</p>)
            case "q":
                return (
                    <blockquote>
                        <strong>
                            {text.content}
                        </strong>
                    </blockquote>
                )
            default:
                return (<p>{text.content}</p>)
        }
    }

    return (
        <div className={`serviceMainContent ${theme}`}>
            <div>
                {position? <img src={image} alt="no-img"/> : null}
                <div className={`"serviceMainContentBlockText`}>
                    <div className={`serviceMainLine ${theme}`}> </div>
                    <h3>{title}</h3>
                    {texts.map((text, i) => {
                        return (
                            <React.Fragment key={`text_${i}`}>{getTagType(text)}</React.Fragment>
                        )
                    })}
                </div>
                {!position? <img src={image} alt="no-img"/> : null}
            </div>
        </div>
    )
}

export function ServiceMainParams({data}){

    const {theme} = useTheme()

    return (
        <div className={`serviceMainParams ${theme}`}>
            <div>
                <div>
                    <h2>Особенности и преимущества:</h2>
                    <ul>
                        {data.features.map(features=>{
                            return (
                                <li key={"features" + features.title}>
                                    <strong>{features.title}</strong>
                                    <p>{features.text}</p>
                                </li>
                            )
                        })}
                    </ul>
                </div>

                <div>
                    <h2>Технические параметры:</h2>
                    <ul>
                        {data.params.map(param=>{
                            return (
                                <li key={"params" + param}>{param}</li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export function ServiceMainParamsCustom({data}){

    const {theme} = useTheme()

    return (
        <div className={`serviceMainParams ${theme}`}>
            <div>
                <div>
                    <h2>{data.fieldName1}:</h2>
                    <ul>
                        {data.features.map(features=>{
                            return (
                                <li key={"features" + features.title}>
                                    <strong>{features.title}</strong>
                                    <p>{features.text}</p>
                                </li>
                            )
                        })}
                    </ul>
                </div>

                <div>
                    <h2>{data.fieldName2}:</h2>
                    <ul>
                        {data.params.map(param=>{
                            return (
                                <li key={"params" + param}>{param}</li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export function ServiceGallery({title, images, backGround, imagesText=[]}) {

    const {theme} = useTheme()

    return (
        <div className={`serviceGallery ${theme}`}>
            <div className={"serviceMainLine"}> </div>
            <h3>{title}</h3>
            <GalleryList images={images} backGround={backGround} imagesText={imagesText}/>
        </div>
    )

}

export function ServiceOptions({ title, data, siteData, theme}) {

    const token = localStorage.getItem('token');
    const [formVisible, setFormVisible] = useState(false);
    const [showAutorisationForm, setShowAutorisationForm] = useState(false);
    const [selectedService, setSelectedService] = useState(null);

    // Состояния для Alert (теперь они здесь)
    const [showAlertNoCancel, setShowAlertNoCancel] = useState(false);
    const [alertNoCancelParams, setAlertNoCancelParams] = useState({
        tittle: "",
        buttonText: "",
        message: "",
        function: null,
        arguments: null,
    });

    const cardTypeText = {
        "product": "о продукте",
        "service": "об услуге"
    };

    const handleOrderClick = (serviceItem) => {
        setSelectedService(serviceItem);

        if (token) {
            setFormVisible(true);
        } else {
            setShowAutorisationForm(true);
        }
    };

    const handleCloseForm = () => {
        setFormVisible(false);
        setShowAutorisationForm(false);
        setSelectedService(null);
    };

    const cardOrder = selectedService ? {
        name: selectedService.text,
        type: "service",
        image: siteData?.image ? getImage(siteData.image) : null
    } : null;

    return (
        <>
            <div className={`serviceOptions ${theme}`}>
                <h2>{title}</h2>
                <div>
                    {data.map((item, i) => {
                        return (
                            <div key={`serviceOptionsLine${i}`} className={"serviceOptionsLine"}>
                                <div className={`serviceOptionsLineTitle ${theme}`}>
                                    <span>{item.text}</span>
                                    <span> </span>
                                    <span
                                        className="service-order-button"
                                        onClick={() => handleOrderClick(item)}
                                    >
                                    Заявка
                                </span>
                                </div>
                                <div className={`serviceOptionsLineAddContent ${theme}`}>
                                    {item.secondText}
                                </div>
                            </div>
                        )
                    })}
                </div>

                {/* Alert компонент */}
                <AlertNoCancel
                    showAlertConfirm={showAlertNoCancel}
                    setShowAlertConfirm={setShowAlertNoCancel}
                    alertConfirmParams={alertNoCancelParams}
                />
            </div>

            {/* Прямое использование OrderForm */}
            {cardOrder && (
                <div className={`product-card-order-formWrapper serviceOptionsForm ${formVisible ? "product-card-order-formVisible" : ""}`}>
                    <OrderForm
                        token={token}
                        cardTypeText={cardTypeText}
                        cardOrder={cardOrder}
                        setShowAutorisationForm={setShowAutorisationForm}
                        setFormVisible={handleCloseForm}
                        setShowAlertNoCancel={setShowAlertNoCancel}
                        setAlertNoCancelParams={setAlertNoCancelParams}
                    />

                    {/* Затемнение для формы */}
                    <div
                        onClick={handleCloseForm}
                        className={`darkSpace ${formVisible ? "darkSpaceVisible" : ""}`}
                    />
                </div>
            )}


            {/* Форма авторизации */}
            <div
                className="dropdown-login"
                style={{display: `${showAutorisationForm ? "block" : "none"}`}}
            >
                <div className="buttonLogin" onClick={authYandex}>
                    <YandexIcon/>
                    Войти через Яндекс ID
                </div>
                <div className="buttonLogin" onClick={authGoogle}>
                    <GoogleIcon/>
                    Войти через Google ID
                </div>
            </div>

            {/* Затемнение для формы авторизации */}
            <div
                onClick={() => setShowAutorisationForm(false)}
                className={`darkSpace ${showAutorisationForm ? "darkSpaceVisible" : ""}`}
            />
        </>

    );
}

const getImage = (path) => {
    if (!path) return "";
    const clean = String(path).replace(/^\.?\//, "");
    return `/images/${clean}`;
}

export function Service() {
    const location = useLocation();
    const siteData = findElementByLink(siteStructure, location.pathname);
    const serviceKey = location.pathname.split('/').filter(Boolean).pop();
    const serviceData = serviceDescription[serviceKey];
    const {theme} = useTheme()


    const seo = siteData?.seo || {
        title: "",
        description: "",
        keywords: "",
        changefreq: 'yearly',
        priority: 0.4
    };

    if (!serviceData) {
        return <div>Услуга не найдена</div>;
    }

    return (
        <div>
            <SeoHelmet
                title={seo.title}
                description={seo.description}
                keywords={seo.keywords}
            />
            <Navigation />
            <div className={`serviceBackground ${theme}`}> </div>

            <div className={"serviceFoundry"}>
                {serviceData.content.map((block, index) => {
                    if (block.serviceTextBackground) {
                        const { text, image } = block.serviceTextBackground;
                        return (
                            <ServiceTextBackground
                                key={`bg-${index}`}
                                text={text}
                                image={getImage(image)}
                            />
                        );
                    }

                    if (block.serviceSteps) {
                        const { firstParagraph, title, stepsText } = block.serviceSteps;
                        return (
                            <ServiceSteps
                                key={`steps-${index}`}
                                firstParagraph={firstParagraph}
                                title={title}
                                stepsText={stepsText}
                                theme={theme}
                            />
                        );
                    }

                    if (block.serviceMainContent) {
                        const { title, image, texts, position } = block.serviceMainContent;
                        return (
                            <ServiceMainContent
                                key={`content-${index}`}
                                title={title}
                                image={getImage(image)}
                                texts={texts}
                                position={position || false}
                                theme={theme}
                            />
                        );
                    }

                    if (block.serviceMainParamsCustom) {
                        return (
                            <ServiceMainParamsCustom
                                key={`params-${index}`}
                                data={block.serviceMainParamsCustom}
                            />
                        );
                    }

                    if (block.serviceMainParams) {
                        return (
                            <ServiceMainParams
                                key={`params-${index}`}
                                data={block.serviceMainParams}
                            />
                        );
                    }

                    if (block.serviceOptions) {
                        const { title, data } = block.serviceOptions;
                        return (
                            <ServiceOptions
                                key={`options-${index}`}
                                title={title}
                                data={data}
                                siteData={siteData}
                                theme={theme}
                            />
                        );
                    }

                    if (block.serviceGallery) {
                        const { title, images, backGround, imagesText } = block.serviceGallery;
                        return (
                            <ServiceGallery
                                key={`gallery-${index}`}
                                title={title}
                                images={images}
                                backGround={backGround}
                                imagesText={imagesText || []}
                            />
                        );
                    }

                    return null;
                })}
            </div>
        </div>
    );
}
